// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"130":"c4627473","251":"2c1fe4a3","860":"1ac79e53"}[chunkId] + ".chunk.css";
};